module.exports = __webpack_public_path__ + "static/banner-9-655c523375d51d6850b79676b6d3668c.jpg";